import '../../styles/web-components/cart-progress.scss';
import { onCartUpdate } from '../services/cart.service';
class CartProgress extends HTMLElement {
    cartStateSub;
    constructor() {
        super();
    }
    connectedCallback() {
        this.cartStateSub = onCartUpdate.subscribe((cart) => {
            this.onCartUpdate(cart);
        });
    }
    disconnectedCallback() {
        this.cartStateSub?.();
    }
    render(config) {
        const isThresholdReached = (config.percentDiff || 0) >= 100;
        const width = Math.min(config.percentDiff || 0, 100);
        this.innerHTML = `
      <div class="cart-progress">
        <div class="cart-progress__threshold-message">${config.message}</div>
        <div class="cart-progress__threshold-container">
          <div
            class="cart-progress__threshold-bar ${isThresholdReached ? 'cart-progress__threshold-bar--reached' : ''}"
            style="width:${width}%"
          ></div>
        </div>
      </div>
    `;
    }
    onCartUpdate(cart) {
        const thresholdData = buildThresholdData(cart.total_price, { ...{ currentCurrency: window.UNTUCKitConfig.cartCurrencySymbol }, ...window.UNTUCKitConfig.thresholds });
        this.render(thresholdData);
    }
}
function buildThresholdData(totalPrice, config) {
    let message = '';
    let percentDiff = null;
    const currency = config.currentCurrency;
    const totalPriceInMoney = totalPrice / 100;
    const punct = config.cartMessagingEndPunctuation;
    if (config.hasFreeShippingThreshold) {
        if (totalPriceInMoney < config.freeShippingThresholdAmount) {
            const diff = config.freeShippingThresholdAmount - totalPriceInMoney;
            percentDiff = totalPrice / config.freeShippingThresholdAmount;
            message = updateCopy(config.freeShippingPromoLabel, currency, diff);
        }
        else {
            message = config.freeShippingPromoQualifiedLabel;
            percentDiff = 100;
        }
        message += punct;
        if (config.shipAfterLabel) {
            message += `<span>(${config.shipAfterLabel})</span>`;
        }
    }
    return { message, percentDiff };
}
function updateCopy(copy, currency, money) {
    return copy.replace("{money}", `${currency + money.toFixed(2)}`);
}
if (!window.customElements.get("cart-progress")) {
    customElements.define("cart-progress", CartProgress);
}
export const _forTesting = {
    buildThresholdData
};
